import { useState, useEffect } from 'react'

export const isE3DAvailable = (): boolean => {
  return !!window.E3D
}

const useE3DAvailability = (is3DExhibitionEnabled: boolean): boolean => {
  const [isE3DAvailable, setIsE3DAvailable] = useState(false)

  useEffect(() => {
    if (!is3DExhibitionEnabled) {
      return
    }

    const checkE3DAvailability = () => {
      if (window.E3D) {
        setIsE3DAvailable(true)
        return true
      }
      return false
    }

    if (checkE3DAvailability()) {
      return
    }

    const checkInterval = setInterval(() => {
      if (checkE3DAvailability()) {
        clearInterval(checkInterval)
      }
    }, 500)

    return () => {
      clearInterval(checkInterval)
    }
  }, [is3DExhibitionEnabled])

  return isE3DAvailable
}

export default useE3DAvailability
